// @ts-check

if (!customElements.get("ff-product-media-gallery")) {
  class ffProductMediaGallery extends HTMLElement {
    constructor() {
      super();

      /**
       * @type {HTMLElement}
       */
      this.ffMediaGallery = (() => {
        /**
         * @type {HTMLElement | null}
         */
        const mediaGallery = document.querySelector(
          ".ff-product-media-gallery"
        );

        if (mediaGallery) {
          return mediaGallery;
        } else {
          throw new Error("Missing media gallery");
        }
      })();

      /**
       * @type {HTMLElement}
       */
      this.ffCloseGalleryButton = (() => {
        /**
         * @type {HTMLElement | null}
         */
        const closeGalleryButton = document.querySelector(
          ".ff-product-media-gallery_close-popup"
        );

        if (closeGalleryButton) {
          return closeGalleryButton;
        } else {
          throw new Error("Missing close gallery button");
        }
      })();
      this.ffCloseGalleryButton.addEventListener("click", () => {
        this.ffMediaGallery.classList.remove("ff-product-media-gallery--open");
        if (this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector) {
          document
            .querySelectorAll(
              this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector
            )
            .forEach((element) => {
              element.style.display = "";
            });
        }
        document.body.style.overflow = "";
      });

      if (this.dataset.ffProductMediaGalleryThumbsSelector) {
        /**
         * @type {FfSlider | null}
         */
        this.ffSliderThumbs = this.querySelector(
          this.dataset.ffProductMediaGalleryThumbsSelector
        );
      }

      /**
       * @type {{[mediaId: string]: Node[]}}
       */
      this.ffThumbsWarehouse = {};

      this.ffThumbsForVideos = [];
      if (this.ffSliderThumbs) {
        /**
         * @type {NodeListOf<HTMLElement>}
         */
        this.ffThumbs = (() => {
          /**
           * @type {NodeListOf<HTMLElement>}
           */
          const thumbs = this.querySelectorAll(
            "[data-ff-product-media-gallery-thumb]"
          );

          thumbs.forEach((thumb) => {
            const mediaId = thumb.dataset.ffProductMediaGalleryThumb;
            const isVideo = thumb.dataset.ffProductMediaGalleryThumbForVideo;
            //If is for video we show it in all groups
            if (isVideo == "true") {
              this.ffThumbsForVideos.push(thumb);
            } else {
              if (mediaId) {
                if (!this.ffThumbsWarehouse[mediaId]) {
                  this.ffThumbsWarehouse[mediaId] = [];
                }

                this.ffThumbsWarehouse[mediaId].push(thumb.cloneNode(true));
              }
            }
          });

          if (thumbs.length > 0) {
            return thumbs;
          } else {
            throw new Error("Missing thumbs");
          }
        })();
      }

      if (this.dataset.ffProductMediaGallerySlidesSelector) {
        /**
         * @type {FfSlider}
         */
        this.ffSliderMedia = (() => {
          /**
           * @type {FfSlider | null}
           */
          const sliderMedia = this.querySelector(
            this.dataset.ffProductMediaGallerySlidesSelector
          );
          if (sliderMedia) {
            return sliderMedia;
          } else {
            throw new Error("Missing media slider");
          }
        })();
      } else {
        throw new Error("Missing media slider selector");
      }

      /**
       * @type {{[mediaId: string]: Node[]}}
       */
      this.ffSlidesWarehouse = {};
      this.ffVideoSlides = [];

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      this.ffSlides = (() => {
        /**
         * @type {NodeListOf<HTMLElement>}
         */
        const slides = this.querySelectorAll(
          "[data-ff-product-media-gallery-slide]"
        );

        slides.forEach((slide) => {
          const mediaId = slide.dataset.ffProductMediaGallerySlide;
          const isVideo = slide.dataset.ffProductMediaGallerySlideIsVideo;
          //If is video we show it in all groups
          if (mediaId) {
            if (isVideo == "true") {
              this.ffVideoSlides.push(slide);
            } else {
              if (!this.ffSlidesWarehouse[mediaId]) {
                this.ffSlidesWarehouse[mediaId] = [];
              }

              this.ffSlidesWarehouse[mediaId].push(slide.cloneNode(true));
            }
          }
        });

        this.ffSliderMedia?.ffSwiper.removeAllSlides;

        if (slides.length > 0) {
          return slides;
        } else {
          throw new Error("Missing media");
        }
      })();

      /**
       * @type {{variantId: string, option: string, mediaId: string}[]}
       */
      this.ffVariantMediaData = (() => {
        const variantGroupsDataEl = this.querySelector(
          "[data-ff-product-media-gallery-variant-groups]"
        );

        if (variantGroupsDataEl?.textContent) {
          /**
           * @type {{variantId: string, option: string, mediaId: string}[]}
           */
          const variantGroupsData = JSON.parse(variantGroupsDataEl.textContent);
          if (variantGroupsData) {
            return variantGroupsData;
          } else {
            throw new Error("Groups data malformed or empty");
          }
        } else {
          throw new Error("Missing groups data");
        }
      })();

      /**
       * @type {{[productOption:string]: string[]}}
       */
      this.ffMediaGroupMap = {};
      let iterations = 0;

      // set up grouping
      let currentMediaOptionName = "";
      this.ffSlides.forEach((media) => {
        const mediaId = media.dataset.ffProductMediaGallerySlide || "";
        for (let i = 0; i < this.ffVariantMediaData.length; i += 1) {
          //Product media is sorted in groups, each group starts with the featured media of a product variant and ends in the featured media of another product variant
          const isFeaturedMedia = mediaId == this.ffVariantMediaData[i].mediaId;

          if (isFeaturedMedia) {
            currentMediaOptionName = this.ffVariantMediaData[i].option;
            break;
          }
          iterations++;
        }
        if (currentMediaOptionName) {
          if (!this.ffMediaGroupMap[currentMediaOptionName]) {
            this.ffMediaGroupMap[currentMediaOptionName] = [];
          }
          this.ffMediaGroupMap[currentMediaOptionName].push(mediaId);
        }
      });

      /**
       * Property containing the value of the variant(product option) to select.
       * e.g. text
       */
      this.ffVariantSelectorProperty = (() => {
        if (this.dataset.ffProductMediaGalleryVariantSelectorProperty) {
          return this.dataset.ffProductMediaGalleryVariantSelectorProperty;
        } else {
          throw new Error("Missing variant selector property");
        }
      })();

      /**
       * Product page elements(buttons, inputs, select options, etc) that change the selected variant of the product
       */
      this.ffVariantSelectors = (() => {
        if (this.dataset.ffProductMediaGalleryVariantSelectorsSelector) {
          /**
           * @type {NodeListOf<HTMLElement>}
           */
          const variantSelectors = document.querySelectorAll(
            this.dataset.ffProductMediaGalleryVariantSelectorsSelector
          );

          if (variantSelectors.length > 0) {
            return variantSelectors;
          } else {
            throw new Error("Missing variant selectors");
          }
        } else {
          throw new Error("Missing variant selectors selector");
        }
      })();

      /**
       * As the variant selectors can be clickable or input, we need the event type
       */
      this.ffVariantSelectorsListener = (() => {
        if (this.dataset.ffProductMediaGalleryVariantSelectorsListener) {
          return this.dataset.ffProductMediaGalleryVariantSelectorsListener;
        } else {
          throw new Error("Missing variant selectors listener");
        }
      })();

      this.ffVariantSelectors.forEach((ffVariantSelector) => {
        ffVariantSelector.addEventListener(
          this.ffVariantSelectorsListener,
          this.ffInitGalleryByOption
        );
      });

      if (this.dataset.ffProductMediaGalleryVariantId) {
        this.ffInitGalleryByVariant(
          this.dataset.ffProductMediaGalleryVariantId
        );
      } else {
        throw new Error("Missing initial variant id");
      }
    }

    ffInitGalleryByVariant = (variantIdSelected) => {
      this.ffSliderMedia.ffSwiper.removeAllSlides();
      this.ffSliderThumbs?.ffSwiper.removeAllSlides();

      for (let { variantId, option } of this.ffVariantMediaData) {
        if (variantId == variantIdSelected) {
          this.ffMediaGroupMap[option]?.forEach((mediaId) => {
            this.ffThumbsWarehouse[mediaId]?.forEach((mediaEL) => {
              this.ffSliderThumbs?.ffSwiper.appendSlide(mediaEL);
            });

            this.ffSlidesWarehouse[mediaId]?.forEach((mediaEL) => {
              this.ffSliderMedia.ffSwiper.appendSlide(mediaEL);

              mediaEL.addEventListener("click", () => {
                this.ffMediaGallery.classList.add(
                  "ff-product-media-gallery--open"
                );

                if (
                  this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector
                ) {
                  document
                    .querySelectorAll(
                      this.dataset
                        .ffProductMediaGalleryHideElementsOnPopupSelector
                    )
                    .forEach((element) => {
                      element.style.display = "none";
                    });
                }

                document.body.style.overflow = "hidden";
              });
            });
          });

          break;
        }
      }

      this.ffThumbsForVideos?.forEach((mediaEL) => {
        this.ffSliderThumbs?.ffSwiper.appendSlide(mediaEL);
      });

      this.ffVideoSlides.forEach((mediaEL) => {
        this.ffSliderMedia.ffSwiper.appendSlide(mediaEL);
        mediaEL.querySelector("video").play();
        mediaEL.addEventListener("click", () => {
          this.ffMediaGallery.classList.add("ff-product-media-gallery--open");

          if (this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector) {
            document
              .querySelectorAll(
                this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector
              )
              .forEach((element) => {
                element.style.display = "none";
              });
          }

          document.body.style.overflow = "hidden";
        });
      });

      if (this.ffSliderThumbs) {
        this.ffSliderThumbs?.ffSwiper.update();
        this.ffSliderMedia?.ffSwiper.update();
      } else {
        this.ffSliderMedia?.ffSwiper.update();
      }
    };

    /**
     *
     * @type {EventListener}
     */
    ffInitGalleryByOption = (e) => {
      let optionSelected = e.currentTarget[this.ffVariantSelectorProperty];
      if (this.ffVariantSelectorProperty.includes(".")) {
        const [property, propertyProperty] =
          this.ffVariantSelectorProperty.split(".");
        optionSelected = e.currentTarget[property][propertyProperty];
      }

      this.ffSliderMedia.ffSwiper.removeAllSlides();
      this.ffSliderThumbs?.ffSwiper.removeAllSlides();
      for (let { option } of this.ffVariantMediaData) {
        if (optionSelected == option) {
          this.ffMediaGroupMap[option].forEach((mediaId) => {
            this.ffThumbsWarehouse[mediaId]?.forEach((mediaEL) => {
              this.ffSliderThumbs?.ffSwiper.appendSlide(mediaEL);
            });

            this.ffSlidesWarehouse[mediaId]?.forEach((mediaEL) => {
              this.ffSliderMedia.ffSwiper.appendSlide(mediaEL);
              mediaEL.addEventListener("click", () => {
                this.ffMediaGallery.classList.add(
                  "ff-product-media-gallery--open"
                );

                if (
                  this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector
                ) {
                  document
                    .querySelectorAll(
                      this.dataset
                        .ffProductMediaGalleryHideElementsOnPopupSelector
                    )
                    .forEach((element) => {
                      element.style.display = "none";
                    });
                }

                document.body.style.overflow = "hidden";
              });
            });
          });

          break;
        }
      }

      this.ffThumbsForVideos?.forEach((mediaEL) => {
        this.ffSliderThumbs?.ffSwiper.appendSlide(mediaEL);
      });

      this.ffVideoSlides.forEach((mediaEL) => {
        this.ffSliderMedia.ffSwiper.appendSlide(mediaEL);
        mediaEL.querySelector("video").play();
        mediaEL.addEventListener("click", () => {
          this.ffMediaGallery.classList.add("ff-product-media-gallery--open");

          if (this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector) {
            document
              .querySelectorAll(
                this.dataset.ffProductMediaGalleryHideElementsOnPopupSelector
              )
              .forEach((element) => {
                element.style.display = "none";
              });
          }

          document.body.style.overflow = "hidden";
        });
      });

      if (this.ffSliderThumbs) {
        this.ffSliderThumbs?.ffSwiper.update();
        this.ffSliderMedia?.ffSwiper.update();
      } else {
        this.ffSliderMedia?.ffSwiper.update();
      }
    };
  }

  customElements.define("ff-product-media-gallery", ffProductMediaGallery);
}
